import CircularOutlineIcon from "@/components/CircularButton/styled/CircularOutlineIcon";
import { iconSizes } from "@/utils/iconProps";
import { themeColors } from "@/utils/themeColors";
import { Plus } from "lucide-react";

const AddFlashcardBtn = ({ onClick }) => {
    return (
        <CircularOutlineIcon
            size={iconSizes.MD}
            Icon={Plus}
            onClick={onClick}
            buttonColor={themeColors.neutralBlack}
            borderColor={themeColors.neutral3}
            color={themeColors.neutralWhite}
            hoverColor={themeColors.neutralWhite}
            tooltip={"Add a flashcard here"}
        />
    );
};

export default AddFlashcardBtn;
